import { Alert, Snackbar } from "@mui/material";
import React from "react";
import ExportReviewDialog from "../../components/ExportReviewDialog";

function CompanySearchNotices({exportReview, isExporting, exportError, setExportReview, setExportError, exportToCSV, saveSearchSnackbar, setSaveSearchSnackbar}) {
  return (<>
      <ExportReviewDialog
        open={Boolean(exportReview)}
        review={exportReview}
        busy={isExporting}
        error={exportError}
        onCancel={() => {
          setExportReview(null);
          setExportError(null);
        }}
        onConfirm={exportToCSV}
      />
      <Snackbar
        open={saveSearchSnackbar.open}
        autoHideDuration={3500}
        onClose={() => setSaveSearchSnackbar((current) => ({ ...current, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity="success"
          variant="filled"
          onClose={() => setSaveSearchSnackbar((current) => ({ ...current, open: false }))}
          sx={{ width: "100%" }}
        >
          {saveSearchSnackbar.message}
        </Alert>
      </Snackbar>
  </>);
}

export { CompanySearchNotices };
